exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn {\r\n   padding: 7px 12px;\r\n}\r\n\r\n@media screen and (min-width: 768px){\r\n  .jumbotron {\r\n\t    padding: 110px 0;\r\n\t}\r\n  .modal-body{\r\n     width: 600px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n .jumbotron {\r\n\t    padding: 85px 0;\r\n\t}\r\n}\r\n\r\ntextarea {\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/orders/issues/issues.component.css
// module id = ../../../../../src/app/components/orders/issues/issues.component.css
// module chunks = main